import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

import {FacadeBaseModel} from '@shared/presentation/facade.base.model';

import {VerifyAuthUseCasePort} from '@features/auth/application/use_cases/verify-auth/verify-auth.use-case.port';
import {VerifyAuthPayloadDto} from '@features/auth/application/use_cases/verify-auth/dto/verify-auth.payload.dto';
import {VerifyAuthResponseDto} from '@features/auth/application/use_cases/verify-auth/dto/verify-auth.response.dto';
import {SpinnerPort} from '@shared/application/ports/spinner/spinner.port';
import {finalize} from 'rxjs';

@Injectable()
export class VerifyAuthFacade extends FacadeBaseModel<VerifyAuthResponseDto | null> {

  private readonly destroyRef = inject(DestroyRef);
  private readonly useCase = inject(VerifyAuthUseCasePort);
  private readonly spinnerPort: SpinnerPort = inject(SpinnerPort);

  constructor() {
    super(null);
  }

  public load(payload: VerifyAuthPayloadDto): void {
    if (this.loading()) {
      return;
    }

    this.resetEvents();
    this.setLoading();

    this.spinnerPort.setVisible();

    this.useCase.execute(payload)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.setIdle();
          this.spinnerPort.setHidden();
        })
      )
      .subscribe({
        next: (response) => {
          this.setData(response);
          this.setSuccess('Proceso exitoso!');
        },
        error: (error: unknown) => {
          this.setError(this.getErrorMessage(error));
        },
      });
  }

  public clear(): void {
    this.reset();
  }

}
